import styled from 'styled-components';
import { DropdownToggle, DropdownMenu } from 'reactstrap';
import { color } from '~/assets/styles/colors';

export const ItemConfig = styled.div`
	padding: 10px;
	border-bottom: 1px solid #d7d7d7;

	font-size: 14px;
	color: ${color.grayDark};
	user-select: none;

	&:last-child {
		border-bottom: none;
	}
`;

export const FilterAndDown = styled.div`
	display: flex;

	justify-content: right;
	margin-bottom: 10px;
`;

export const TextClick = styled.div`
	cursor: pointer;

	margin-right: 20px;
	font-size: 18px;

	svg {
		color: ${color.secondary};
	}
`;

export const TrStyled = styled.tr`
	background: ${color.primary};
	color: ${color.black} !important;

	th {
		padding: 10px !important;

		&:not(:last-child) {
			border-right: 1px solid ${color.black} !important;
		}

		&::after {
			width: 0 !important;
		}
	}
`;

export const DropdownToggleStyled = styled(DropdownToggle)`
	background-color: ${color.yellow} !important;

	&:hover {
		background-color: ${color.yellow} !important;
		color: ${color.black} !important;
		filter: brightness(85%);
	}
`;

export const DropdownMenuStyled = styled(DropdownMenu)`
	border: 1px solid ${color.gray};
	border-radius: 10px !important;
	box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);

	& .dropdown-item {
		&:hover {
			color: ${color.secondary} !important;
		}
	}

	button {
		&:last-child {
			border-bottom: 0 !important;
		}
	}
`;
